package nl.astraeus.wiki.domain

import nl.astraeus.wiki.encoding.Tokenizable
import nl.astraeus.wiki.encoding.Tokenizer

class Page(
  var id: Long,
  var wiki: Long,
  var parent: Long?,
  var title: String,
  var content: String,
)

data class WikiPageDto(
  val id: Long,
  val wikiId: String,
  var parentId: Long,
  var title: String,
) : Tokenizable {

  constructor(token: Tokenizer) : this(
    token.next().toLong(),
    token.next(),
    token.next().toLong(),
    token.next(),
  )

  override fun tokenize(): String = Tokenizer.tokenize(
    id.toString(),
    wikiId,
    parentId.toString(),
    title,
  )
}

data class PageListDto(
  val id: Long,
  val wikiId: String,
  var parentId: String,
  val title: String,
) : Tokenizable {

  constructor(token: Tokenizer) : this(
    token.next().toLong(),
    token.next(),
    token.next(),
    token.next(),
  )

  override fun tokenize(): String = Tokenizer.tokenize(
    id.toString(),
    wikiId,
    parentId,
    title,
  )

}
